type Level = 'info' | 'warn' | 'error';
export function log(level: Level, event: string, detail: Record<string, unknown> = {}) {
  // Do not log responses, reading excerpts, or answer keys. IDs make failures traceable.
  console[level](`[daily:${event}]`, { time: new Date().toISOString(), ...detail });
}
